export const replaceByObject = (value: string, toReplace: any) => {
    return value.replace(/{([^{}]+)}/g, (keyExpr, key) => {
        return toReplace[key] || '';
    });
};
